// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"1c4101c6","146":"e8053348","210":"4764ce91","237":"bce1376e","266":"973e58d4","536":"b247c5cb","728":"2ac4ebdd","778":"e941ecf2","787":"cda612ba","910":"a1d01269"}[chunkId] + ".chunk.js";
};